/**
 * Gets the current pages' entityId
 *
 * @return {[string]} - Current pages' entityId (if it exists)
 */
export function getCurrentPageEntityId(): string | null | undefined {
    if (typeof Peep !== 'undefined' && Peep.currentPeep) {
        return Peep.currentPeep.id;
        // @ts-expect-error
    } else if (window.currentLead) {
        // @ts-expect-error
        return `${window.currentLead.id}-leads`;
    } else {
        return null;
    }
}
